import request from '@/utils/request'
import api from '@/api'
import { arrayObjectSort } from '@/utils'
import store from '@/store'

const state = () => ({})
const getters = {
  async getSurveyUrl() {
    let H5Host = api.H5Host
    // todo config后面要去掉 zeyu/survey/
    //SurveyHost = SurveyHost.substr(0, SurveyHost.indexOf('.com/') + 5)
    let tenant = await store.getters['user/getTenant']
    const code = tenant.TenantCode === 'www' ? 'wwww' : tenant.TenantCode
    const url = `${H5Host}${code}/survey/`
    return url
  },
  async getH5Url() {
    let H5Host = api.H5Host
    // todo config后面要去掉 zeyu/survey/
    //SurveyHost = SurveyHost.substr(0, SurveyHost.indexOf('.com/') + 5)
    let tenant = await store.getters['user/getTenant']
    const code = tenant.TenantCode === 'www' ? 'wwww' : tenant.TenantCode
    const url = `${H5Host}${code}/`
    return url
  },
}

const mutations = {}

const actions = {
  IndustryGetAll(context, params) {
    return request({
      url: api.IndustryGetAll,
      method: 'GET',
      params,
    })
  },
  TenantAvailable(context, params) {
    return request({
      url: api.TenantAvailable,
      method: 'GET',
      params,
    })
  },
  TenantRegister(context, params) {
    return request({
      url: api.TenantRegister,
      method: 'POST',
      data: params,
    })
  },
  TenantApply(context, params) {
    return request({
      url: api.TenantApply,
      method: 'POST',
      data: params,
    })
  },
  TenantGetListByOwner(context, params) {
    return request({
      url: api.TenantGetListByOwner,
      method: 'GET',
      params,
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
